// extracted by mini-css-extract-plugin
module.exports = {"TableWrapper":"TableCollection_TableWrapper__XeiMD"};